import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from 'projects/shared/lib/directives/directives.module';
import { LoginAsBaseComponent } from './login-as-base.component';
import { LoadingIndicatorComponent } from '../../shared/base/loading-indicator/loading-indicator.component';


@NgModule({
  declarations: [
    LoginAsBaseComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    LoadingIndicatorComponent,
    DirectivesModule,
  ]
})
export class LoginAsBaseModule { }
